import { defineStore } from "pinia";

import { CurrentState } from "./types";

export interface favoriteItem {
  items: CurrentState[];
}

export const favoriteStore = defineStore("favoriteStore", {
  state: (): favoriteItem => ({
    items: [],
  }),
  getters: {},
  actions: {
    getItemById(Id: string) {
      if (this.items !== null) {
        const existItem = this.items.filter(
          (cs: CurrentState) => cs.CurrentType === Id
        );
        if (existItem.length) {
          return existItem[0];
        }
      }
      return null;
    },
    addItem(cs: CurrentState) {
      this.items = this.items.filter(
        (selfCs: CurrentState) => selfCs.CurrentType != cs.CurrentType
      );
      this.items.push(cs);
    },
  },
});
